import { EnvelopeIcon, PhoneIcon } from "@heroicons/react/24/outline";
import { IconcsCardProps } from "components/Icons/IconcsCard";
import defaultImage4 from "../../src/images/a.jpeg";
import defaultImage2 from "../../src/images/prestataire/ajout-prestation.png";
import defaultImage3 from "../../src/images/prestataire/demande-devis.png";
import defaultImage1 from "../../src/images/prestataire/inscription-prestataire.png";
import gifImg from "../../src/images/commentcamarche/etapes locataire reservation.gif";
import resGifImg from "../../src/images/etapes_hote_ajout_espace.gif";
import prestaGifImg from "../../src/images/etapes_prestataires_site.gif";

import icon1 from "../../src/images/1.svg";
import icon2 from "../../src/images/2.svg";
import icon3 from "../../src/images/3.svg";

import users from "../../src/images/Icons_owner/7.png";
import controle from "../../src/images/Icons_owner/8.png";
import payment from "../../src/images/Icons_owner/9.png";
import support from "../../src/images/Icons_owner/10.png";
import marketing from "../../src/images/Icons_owner/11.png";
import mesure from "../../src/images/Icons_owner/12.png";
// images for owner call to action
import rooftop from "../../src/images/locations/24.png";
import loft from "../../src/images/locations/25.png";
import reception from "../../src/images/locations/26.png";
import bureau from "../../src/images/locations/27.png";
import studio from "../../src/images/locations/28.png";
import spa from "../../src/images/locations/29.png";
import jardin from "../../src/images/locations/30.png";
import theatre from "../../src/images/locations/1.jpg";
import boutique from "../../src/images/locations/31.png";
import peniche from "../../src/images/locations/32.png";

import mariage from "../../src/images/icons_type_events/13.png";
import anniversaire from "../../src/images/icons_type_events/14.png";
import evjf from "../../src/images/icons_type_events/15.png";
import Barbeque from "../../src/images/icons_type_events/16.png";
import cinema from "../../src/images/icons_type_events/17.png";
import bebe from "../../src/images/icons_type_events/18.png";
import bar from "../../src/images/icons_type_events/19.png";
import relax from "../../src/images/icons_type_events/20.png";
import love from "../../src/images/icons_type_events/21.png";
import home from "../../src/images/icons_type_events/22.png";
import people from "../../src/images/icons_type_events/23.png";
import peace from "../../src/images/icons_type_events/24.png";

import {
  CallToActionBenefits,
  ContactFormInformations,
  FAQ,
  HowItWorkCallToActionProps,
  OwnerCallToActionCardData,
  PlanFeature,
  Step,
  WidgetFooterMenu,
} from "./types";
export const CONTACT_FORM_INFORMATIONS: ContactFormInformations[] = [
  {
    title: "EMAIL",
    icon: <EnvelopeIcon className="inline-block w-5 h-5 mr-2" />,
    desc: "support@eventtobee.com",
  },
  {
    title: "Téléphone",
    icon: <PhoneIcon className="inline-block w-5 h-5 mr-2" />,
    desc: "09 77 93 30 63",
  },
];
export const CONTACT_FORM_FAQ: FAQ[] = [
  {
    question: "Quels types d’espaces à louer proposez-nous ?",
    answer:
      "Nous proposons une large sélection d’espaces pour événements privés, tels que salles de réception, domaines, lofts et lieux atypiques, parfaits pour mariages, anniversaires, fêtes privées ou événements culturels. Nous disposons aussi de salles adaptées aux événements professionnels comme les réunions, conférences, séminaires, et plus encore.",
  },
  {
    question: "Comment être sûr que l’espace correspond vraiment à mes attentes ?",
    answer:
      "Chaque annonce est complétée avec des informations détaillées. Notre plateforme vous permet également de sélectionner les espaces à louer selon le type d’événement que vous voulez organiser. Tout est pensé pour vous aider à faire le bon choix.",
  },
  {
    question: "Les prix sont-ils définitifs ou y a-t-il des frais supplémentaires ?",
    answer:
      "La transparence est essentielle chez Event To Bee : les prix affichés englobent les frais de service et les charges locatives, sans frais cachés.",
  },
  {
    question: "Puis-je annuler ma réservation si mon événement est annulé ?",
    answer:
      "Vous pouvez annuler une réservation jusqu’à cinq jours avant la date prévue pour la location de l’espace. Vous serez remboursé, exception faite des frais de traitement (30 % du HT) de la réservation. Au-delà de ce délai, aucun remboursement ne sera effectué. Nous vous accompagnons pour trouver des options flexibles adaptées aux besoins des entreprises, des professionnels et des particuliers.",
  },

  {
    question: "Comment garantissez-vous la sécurité de la transaction et la fiabilité des hôtes ?",
    answer:
      "EventToBee sécurise toutes les transactions via des plateformes fiables et protège vos données. Nous vérifions soigneusement chaque hôte et espace pour garantir qualité et sécurité, afin que vous puissiez louer en toute confiance.",
  },

  {
    question: "Je souhaite mettre mon espace en location, comment ça fonctionne ?",
    answer:
      "En tant qu’hôte, vous bénéficiez d’un accompagnement complet, d’une visibilité accrue et d’un service client dédié pour maximiser vos réservations. Vous n’avez qu’à créer votre compte pour entamer la mise en ligne de votre espace. Que vous louiez un local professionnel, une salle de réception ou un loft événementiel, nous vous aidons à trouver des locataires qualifiés.",
  },

  {
    question: "Quels types d’événements puis-je organiser dans les espaces à louer avec Event To Bee ?",
    answer:
      "Que ce soit pour un mariage, un anniversaire, une fête privée ou un lancement de produit, ou encore pour une réunion professionnelle, un séminaire, un team building, une formation, une conférence ou un showroom, nos espaces s’adaptent à toutes les configurations et à tous vos événements, privés comme professionnels.",
  },
];

export const WIDGET_MENU: WidgetFooterMenu[] = [
  {
    id: "5",
    title: "Accueil",
    menus: [
      { href: "/login", label: "" },
      { href: "/login", label: "Créer un compte" },
      { href: "/prestataire-evenementiel-paris", label: "Inscription prestataire" },
    ],
  },

  {
    id: "1",
    title: "Réservation",
    menus: [
      { href: "/espace-evenementiel", label: "Espaces" },
      { href: "/prestations", label: "Prestations " },
    ],
  },
  {
    id: "2",
    title: "Blog",
    menus: [{ href: "/blogs", label: "Blog" }],
  },

  {
    id: "6",
    title: "FAQ",
    menus: [{ href: "/faq", label: "Forum aux questions" }],
  },

  {
    id: "4",
    title: "Eventtobee.com",
    menus: [
      { href: "/location-evenement", label: "Qui sommes-nous ?" },
      { href: "/howItWorks", label: "Comment ça marche?" },
      { href: "/espaces-a-louer-ile-de-france", label: "Contactez-nous" },
      { href: "/cookies", label: "Gestion des cookies" },
    ],
  },
];

export const PRESTA_BENEFITS: CallToActionBenefits[] = [
  {
    id: 1,
    icon: icon1,
    title: "Mettez en valeur vos services",
    description:
      "Présentez vos prestations de manière professionnelle et attirez l’attention des clients potentiels avec une vitrine optimisée.",
  },
  {
    id: 2,
    icon: icon2,
    title: "Atteignez de nouveaux publics engagés",
    description:
      "Touchez une audience ciblée à la recherche de services événementiels à Paris, augmentant ainsi votre visibilité.",
  },
  {
    id: 3,
    icon: icon3,
    title: "Contact direct avec les clients",
    description:
      "Établissez une communication fluide et directe avec vos clients pour des collaborations efficaces et rapides.",
  },
];

export const OWNER_BENEFITS: CallToActionBenefits[] = [
  {
    id: 1,
    icon: users,
    title: "Touchez de nouveaux clients qualifiés",
    description:
      "Nous sommes la plateforme de réservation d’espaces événementiels en plein essor. Chaque jour, de nouveaux clients nous font confiance pour trouver le lieu parfait, et notre communauté ne cesse de grandir",
  },
  {
    id: 2,
    icon: controle,
    title: "Vous avez le contrôle",
    description:
      "Vous avez la liberté de définir vos conditions de location (capacité d'accueil, disponibilités, niveau sonore à respecter, types d'événements, l'autorisation d'alcool, la politique concernant le tabac et les animaux de compagnie...)",
  },
  {
    id: 3,
    icon: payment,
    title: "Paiement sécurisé",
    description:
      "Vous recevrez votre paiement par virement dans un délai de 24 à 48 heures après la réalisation de l’événement.",
  },
  {
    id: 4,
    icon: support,
    title: "Support et assistance",
    description:
      "Besoin d’aide pour gérer une demande ou un échange client ? Notre support est là pour vous accompagner et assurer le bon déroulement de chaque réservation.",
  },
  {
    id: 5,
    icon: marketing,
    title: "Plans marketing personnalisés",
    description:
      "Nos campagnes ciblées sur les réseaux sociaux, les publicités en ligne et l’e-mailing vous permettent de toucher les bons clients. Vous accédez également à des données utiles pour optimiser votre présence et vos performances. ",
  },
  {
    id: 6,
    icon: mesure,
    title: "Faites briller votre espace",
    description:
      "Notre équipe vous accompagne pour créer un profil attrayant et bien référencé, afin de capter l’attention des bons clients.",
  },
];

export const PRESTA_FAQ = [
  {
    question: "Comment puis-je annuler ou supprimer une annonce ?",
    answer:
      'Vous pouvez suspendre ou annuler votre annonce à tout moment en envoyant un e-mail à <a href="mailto:prestataires@eventtobee.com" class="text-blue-500 underline">prestataires@eventtobee.com</a>. Nous la supprimerons immédiatement.',
  },
  {
    question: "L'inscription en tant que prestataire est-elle payante ?",
    answer:
      "L'inscription en tant que prestataire sur EventToBee est entièrement gratuite. Vous pouvez créer votre compte, publier vos prestations et commencer à recevoir des demandes sans aucun frais d'inscription.",
  },
  {
    question: "Puis-je publier plusieurs annonces de prestations ?",
    answer:
      "Oui, si vous proposez plusieurs prestations distinctes, vous pouvez ajouter autant d'annonces que nécessaire pour présenter l’ensemble de vos services",
  },
  {
    question: "Comment fonctionne le processus de demande de devis ?",
    answer:
      "Les clients peuvent vous contacter pour toute demande de renseignements ou de devis. Vous pourrez leur répondre directement depuis votre compte et gérer vos demandes de manière autonome.",
  },
];

export const RESERVATION_FAQ = [
  {
    question: "Quels types d’espace événementiel puis-je trouver sur EventToBee ?",
    answer:
      "Vous trouverez des salles de réception, lofts, studios, jardins, villas, péniches, spas, vérandas, boutiques éphémères, etc., adaptés à tous types d’événements privés ou professionnels.",
  },
  {
    question: "Comment puis-je vérifier la disponibilité d’un espace événementiel ?",
    answer:
      "Chaque fiche d’espace indique ses disponibilités actualisées. Vous pouvez également contacter directement le propriétaire ou le gestionnaire pour confirmer la disponibilité et organiser une visite.",
  },
  {
    question: "Quels critères dois-je prendre en compte pour choisir un espace événementiel ?",
    answer:
      "Tenez compte de la capacité d’accueil, de la localisation, des équipements disponibles, de l’accessibilité, du style du lieu, et de votre budget. Consultez également les avis clients pour faire le meilleur choix.",
  },
];

export const OWNER_FAQ = [
  {
    question: "Quelles sont les conditions d’annulation des forfaits ?",
    answer:
      'Les forfaits EventToBee sont renouvelés automatiquement chaque année.Vous pouvez les annuler à tout moment en nous envoyant un e-mail à <a href="mailto:abonnement@eventtobee.com" class="text-blue-500 underline">abonnement@eventtobee.com </a> au moins deux mois avant la date de renouvellement.',
  },
  {
    question: "Combien de temps faut-il pour que mon espace soit en ligne ?",
    answer:
      "Créer un compte ne prend que quelques minutes. Vous pouvez ensuite ajouter votre espace immédiatement.Pensez à préparer les informations clés (description, capacité, photos, équipements) pour gagner du temps.Une fois votre annonce complétée, notre équipe l’examine rapidement, la valide, puis la met en ligne. Si besoin, nous vous proposerons des ajustements pour maximiser son impact.",
  },
  {
    question: "Comment fonctionnent les paiements en ligne sur EventToBee ?",
    answer:
      "EventToBee utilise la solution sécurisée Stripe Connect pour gérer les paiements en ligne. Lorsqu’un client réserve votre espace via la plateforme, le paiement est collecté en toute sécurité et transféré automatiquement sur votre compte Stripe connecté.Une fois la réservation terminée, le montant (déduit de la commission EventToBee) est viré directement sur votre compte bancaire, généralement dans un délai de 7 jours. Vous n’avez rien à gérer manuellement : la commission est prélevée automatiquement, ce qui simplifie votre comptabilité et évite les factures ou relances.",
  },
  {
    question: "Dois-je signer un contrat pour publier mon espace sur EventToBee ?",
    answer:
      "Non, aucun contrat d’engagement n’est nécessaire. Vous pouvez publier votre espace en toute liberté et vous désinscrire à tout moment, sans formalité compliquée.En rejoignant EventToBee, vous acceptez simplement nos conditions générales d’utilisation, et c’est tout !",
  },
];

export const PRESTA_HOW_IT_WORKS: Required<Omit<HowItWorkCallToActionProps, "steps">> & { steps: Step[] } = {
  title: "Comment ajouter vos prestations",
  titleHighlight: "événementiel",
  steps: [
    {
      number: 1,
      title: "Rejoignez EventToBee en créant votre compte prestataire",
      description: [
        "Créez votre compte en quelques minutes, présentez vos services et démarquez-vous auprès de clients à la recherche de prestations de qualité.",
        "Recevez des demandes directement, échangez librement avec vos clients, et gérez votre activité en toute autonomie depuis votre espace dédié.",
      ],
      image: prestaGifImg,
      circleWidth: "w-20",
      circleHeight: "h-12",
    },
    {
      number: 2,
      title: "Ajoutez et publiez vos prestations",
      description: [
        "Décrivez vos services : type de prestation, tarifs, photos, et options proposées. Une fois votre offre ajoutée, elle sera publiée et accessible à nos clients en recherche active.",
        "Mettez en valeur votre savoir-faire et commencez à recevoir des demandes dès la mise en ligne !",
      ],
      image: prestaGifImg,
      circleWidth: "w-24",
      circleHeight: "h-12",
    },
    {
      number: 3,
      title: "Soyez attentif aux demandes des clients",
      description: [
        "Vous pouvez répondre aux demandes de devis depuis votre compte et échanger directement avec les clients.",
      ],
      image: prestaGifImg,
      circleWidth: "w-16",
      circleHeight: "h-12",
    },
  ],
  gradientFrom: "gray-50",
  gradientTo: "gray-200",
  stepCircleColor: "bg-eventToBeePink",
  bg: "bg-gradient-to-br",
};

export const OWNER_HOW_IT_WORKS: Required<Omit<HowItWorkCallToActionProps, "steps">> & { steps: Step[] } = {
  title: "Comment ajouter votre espace ?",
  titleHighlight: "événementiel",
  steps: [
    {
      number: 1,
      title: "Inscrivez votre espace gratuitement",
      description: [
        "Créez votre compte en quelques clics, ajoutez vos espaces et définissez vos tarifs. C’est simple, rapide, et entièrement gratuit !",
      ],
      image: resGifImg,
      circleWidth: "w-20",
      circleHeight: "h-12",
    },
    {
      number: 2,
      title: "Ajoutez votre espace en un clic",
      description: [
        "Ajoutez votre espace directement depuis votre compte en cliquant sur le bouton “Ajouter votre espace”.",
        "Remplissez ensuite le formulaire avec les détails essentiels : capacité, équipements, photos…",
        "Plus votre annonce est complète, plus vous avez de chances d’attirer des demandes qualifiées",
      ],
      image: resGifImg,
      circleWidth: "w-16",
      circleHeight: "h-12",
    },
    {
      number: 3,
      title: "Validation par l’équipe EventToBee",
      description: [
        "Notre équipe vérifie votre annonce avant sa mise en ligne pour garantir une expérience de qualité à tous nos utilisateurs. Une fois validé, votre espace devient immédiatement visible dans les résultats de recherche.",
      ],
      image: resGifImg,
      circleWidth: "w-32",
      circleHeight: "h-12",
    },
    {
      number: 4,
      title: "Recevez des demandes et des avis",
      description: [
        "Gérez vos réservations depuis votre compte EventToBee. Vous échangez directement avec les clients et collectez des avis pour renforcer votre visibilité.",
      ],
      image: resGifImg,
      circleWidth: "w-24",
      circleHeight: "h-12",
    },
  ],
  gradientFrom: "gray-50",
  gradientTo: "gray-200",
  stepCircleColor: "bg-eventToBeePink",
  bg: "bg-gradient-to-br",
};

export const RESERVATION_HOW_IT_WORKS: Required<Omit<HowItWorkCallToActionProps, "steps">> & { steps: Step[] } = {
  title: "Comment réserver votre espace événementiel ?",
  titleHighlight: "événementiel",
  steps: [
    {
      number: 1,
      title: "Trouvez le lieu parfait",
      description: [
        "Utilisez notre plateforme pour parcourir une sélection variée d’espaces événementiels : lofts, salles de réception, jardins, studios, villas, péniches... Filtrez selon vos besoins : capacité d’accueil, type d’événement, localisation précise. Filtrez par type d’espace (loft, salle de réception, studio, villa, jardin, péniche, etc.), localisation à Paris, Île-de-France et partout en France et capacité d’accueil pour trouver le lieu idéal.",
      ],
      image: gifImg,
      circleWidth: "w-72",
      circleHeight: "h-12",
    },
    {
      number: 2,
      title: "Consultez les disponibilités",
      description: [
        "Découvrez en un coup d’œil les lieux disponibles correspondant à vos critères. Consultez les fiches détaillées, incluant descriptions, photos, tarifs et disponibilités mises à jour.",
        "Accédez à une sélection d’espaces événementiels vérifiés et disponibles, adaptés à tous types de projets, qu’ils soient professionnels ou privés.",
      ],
      image: gifImg,
      circleWidth: "w-28",
      circleHeight: "h-12",
    },
    {
      number: 3,
      title: "Choisissez en toute confiance",
      description: [
        "Appuyez-vous sur les avis clients pour vous aider à faire le meilleur choix. Sélectionnez l’espace qui correspond parfaitement à votre projet et réservez en quelques clics. ",
      ],
      image: gifImg,
      circleWidth: "w-28",
      circleHeight: "h-12",
    },
    {
      number: 4,
      title: "Échangez directement avec les propriétaires",
      description: [
        "Envoyez une demande d’informations . Discutez des détails de votre événement, planifiez une visite ou vérifiez les conditions de réservation.",
      ],
      image: gifImg,
      circleWidth: "w-24",
      circleHeight: "h-12",
    },
  ],
  gradientFrom: "gray-50",
  gradientTo: "gray-200",
  stepCircleColor: "bg-eventToBeePink",
  bg: "bg-gradient-to-br",
};

export const OWNER_EVENTS_DATA: IconcsCardProps[] = [
  { icon: mariage, label: "Mariage" },
  { icon: anniversaire, label: "Anniversaire" },
  { icon: evjf, label: "EVJF" },
  { icon: Barbeque, label: "Barbecue" },
  { icon: cinema, label: "Shotting/Tournage" },
  { icon: bebe, label: "Baby shower" },
  { icon: bar, label: "Évènement d'entreprise" },
  { icon: relax, label: "Yoga" },
  { icon: love, label: "Love room" },
  { icon: home, label: "Videdressing" },
  { icon: people, label: "Détente entre amis" },
  { icon: peace, label: "Baptême" },
];

export const OWNER_CALL_TO_ACTION_IMAGES: OwnerCallToActionCardData[] = [
  {
    id: 1,
    title: "Salle de réception",
    image: reception,
    to: "/espace-evenementiel",
    height: "245px",
    colSpan: { lg: 4, md: 1 },
  },
  {
    id: 2,
    title: "Loft",
    image: loft,
    to: "/espace-evenementiel",
    height: "245px",
    colSpan: { lg: 4, md: 1 },
  },
  {
    id: 3,
    title: "Rooftop",
    image: rooftop,
    to: "/espace-evenementiel",
    height: "245px",
    colSpan: { lg: 4, md: 1 },
  },
  {
    id: 4,
    title: "Bureau , salle de réunion",
    image: bureau,
    to: "/espace-evenementiel",
    height: "245px",
    colSpan: { lg: 7, md: 1 },
  },
  {
    id: 5,
    title: "Studio",
    image: studio,
    to: "/espace-evenementiel",
    height: "245px",
    colSpan: { lg: 9, md: 2 },
  },
  {
    id: 6,
    title: "Hammam / Spa",
    image: spa,
    to: "/espace-evenementiel",
    height: "245px",
    colSpan: { lg: 4, md: 1 },
  },
  {
    id: 7,
    title: "Jardin / Piscine / Terrase",
    image: jardin,
    to: "/espace-evenementiel",
    height: "245px",
    colSpan: { lg: 4, md: 1 },
  },
  {
    id: 8,
    title: "Théâtre",
    image: theatre,
    to: "/espace-evenementiel-paris",
    height: "245px",
    colSpan: { lg: 4, md: 1 },
  },
  {
    id: 9,
    title: "Boutique éphémère",
    image: boutique,
    to: "/espace-evenementiel",
    height: "245px",
    colSpan: { lg: 8, md: 4 },
  },
  {
    id: 10,
    title: "Péniche",
    image: peniche,
    to: "/espace-evenementiel",
    height: "245px",
    colSpan: { lg: 5, md: 4 },
  },
];

export const basicFeatures: PlanFeature[] = [
  { name: "Bonne visibilité à la page d'accueil", included: true },
  { name: "Amélioration de la mise en forme de votre hôte", included: true },
  { name: "Contact direct avec le client", included: true },
  { name: "Campagne de marketing multi canal", included: false },
  { name: "Rapport et analyse stratégique", included: false },
];

export const premiumFeatures: PlanFeature[] = [
  { name: "Bonne visibilité à la page d'accueil", included: true },
  { name: "Amélioration de la mise en forme de votre hôte", included: true },
  { name: "Contact direct avec le client", included: true },
  { name: "Campagne de marketing multi canal", included: true },
  { name: "Rapport et analyse stratégique", included: true },
];

export const itemPerDashborad = 20;
export const itemPerDashboradClient = 20;
export const itemPerDashboradPrestation = 10;
export const itemPerPrestationsPage = 30;
export const itemPerLocationsPage = 30;
